import { Config } from '@/models/config';
import httpClient from '@/services/httpClient';
import { names } from '../modules';

export function registerMediators(store: any) {

    store.subscribe((mutation: any) => {
        switch (mutation.type) {
            case `${names.Configuration}/setConfig`:
                const config = mutation.payload as Config;
                httpClient.defaults.baseURL = config.baseURL;
                break;
        }
    });
}

